import { Field, Form, Formik, useFormikContext } from "formik";
import { observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { inValidCharacterForStoreName } from "../../../../../constants/constants";
import { useStore } from "../../../../../contexts/store-provider";
import { paymentInitialState } from "../../../../../core/initialState/master-settings-state";
import LoaderButton from "../../../../../shared-components/button/loader-button";
import FormikFormInput from "../../../../../shared-components/FormikFormHandlers/FormikFormInput";
import { paymentSettingsValidationSchema } from "../../../../../shared-components/FormikFormHandlers/FormikValidationSchema";
import Label from "../../../../../shared-components/label/label";
interface IProps {
  id: number;
  initialValues: any;
  submitHandler: (data: any) => void;
  addUpdateInProgress: boolean;
  actionSuccess: boolean;
  onCancelEdit: () => void;
}

const AddPaymentSettingsForm: React.FC<IProps> = (props: IProps) => {
  const {
    submitHandler,
    addUpdateInProgress,
    actionSuccess,
    initialValues,
    id,
    onCancelEdit,
  } = props;
  const { masterManagementStore } = useStore();
  const { addUpdatePaymentSettingState } = masterManagementStore;
  let resetPresForm = () => {};
  const [initialValue, setInitialValue] = useState<any>({
    ...initialValues,
  });
  const FormObserver: React.FC = () => {
    const { values } = useFormikContext<any>();
    return null;
  };

  /**
   * This functional component stores the reset form function in the resetPresentForm variable
   */
  const ResettingForm = () => {
    const { resetForm } = useFormikContext();
    resetPresForm = resetForm;
    return null;
  };

  useEffect(() => {
    if (addUpdatePaymentSettingState) {
      setInitialValue({ ...paymentInitialState });
      resetPresForm();
    }
  }, [addUpdatePaymentSettingState]);

  useEffect(() => {
    if (actionSuccess) {
      resetPresForm();
      setInitialValue({ ...paymentInitialState });
    }
  }, [actionSuccess]);

  return (
    <>
      <Formik
        initialValues={{ ...initialValues }}
        enableReinitialize
        validationSchema={paymentSettingsValidationSchema}
        onSubmit={async (values: any) => {
          submitHandler(
            id > 0
              ? {
                  ...values,
                  Id: id,
                  IsNameUpdated: values.Name !== initialValues.Name,
                }
              : {
                  Description: values.Description,
                  Name: values.Name,
                }
          );
        }}
      >
        {({ values, resetForm }) => (
          <>
            <Form className="setting-form" noValidate>
              <FormObserver />
              <Row className="position-relative">
                <Col sm={5} md={5} lg={5} xl={5}>
                  <Label
                    className="form-label"
                    required={true}
                    label="payment_name"
                  />
                  <Field
                    className="form-control"
                    aria-label="Default select example"
                    name="Name"
                    placeholder="enter_payment_name"
                    as={FormikFormInput}
                    invalidcharacter={inValidCharacterForStoreName}
                  />
                </Col>
                <Col sm={5} md={5} lg={5} xl={5}>
                  <Label
                    className="form-label"
                    required={false}
                    label="description"
                  />
                  <Field
                    className="form-control"
                    aria-label="Default select example"
                    name="Description"
                    placeholder="description"
                    as={FormikFormInput}
                    validcharacter={[
                      "・",
                      "／",
                      "－",
                      "～",
                      "＋",
                      "（",
                      "）",
                      "［",
                      "］",
                      "※",
                      "：",
                      "★",
                      "☆",
                      "◎",
                      "○",
                      "●",
                      "◆",
                      "◇",
                      "■",
                      "□",
                      "→",
                      "⇒",
                      "♪",
                      "(",
                      ")",
                      "【",
                      "】",
                      "￥",
                      '"',
                      "＜",
                      "＞",
                      "！",
                      "？",
                      "↓",
                      "↑",
                      "←",
                      "．",
                      '"',
                      "゛",
                      "'",
                      "'",
                      '"',
                      '"',
                      "、",
                      "。",
                      "《",
                      "》",
                      "+",
                      "-",
                      "[",
                      "]",
                      "|",
                      "*",
                      "&",
                      "/",
                      ".",
                      "!",
                      "@",
                      "#",
                      "$",
                      "%",
                      "^",
                      "_",
                      "`",
                      "{",
                      "}",
                      "?",
                      ";",
                      ":",
                      ",",
                      "=",
                      "~",
                      "<",
                      ">",
                    ]}
                  />
                  <p className="small text-muted text-end mt-1">{`${
                    values.Description ? values.Description.length : 0
                  }/300`}</p>
                </Col>
                <Col sm={2} md={2} lg={2} xl={2}>
                  <LoaderButton
                    type="submit"
                    className="label-top-margin "
                    isLoading={addUpdateInProgress}
                    disabled={addUpdateInProgress}
                    text={id > 0 ? "button_update" : "add"}
                  />

                  {id > 0 && (
                    <LoaderButton
                      type="button"
                      className="label-top-margin ms-2"
                      variant="danger"
                      onClick={() => {
                        onCancelEdit();
                        setInitialValue({ ...paymentInitialState });
                        resetPresForm();
                        resetForm({ values: paymentInitialState });
                      }}
                      isLoading={false}
                      disabled={addUpdateInProgress}
                      text="button_cancel"
                    />
                  )}
                </Col>
              </Row>

              <ResettingForm />
            </Form>
          </>
        )}
      </Formik>
    </>
  );
};

export default observer(AddPaymentSettingsForm);
